import React from 'react';
import classNames from 'classnames';
import Item from './Item';
import styles from './index.module.scss';
const Accordion = ({ itemsList, isFullWidth, isDark }) => {
    const classes = classNames({
        [styles.listWrap]: true,
        [styles.fullWidth]: isFullWidth,
        [styles.darkLayout]: isDark
    });
    return (React.createElement("div", { className: classes }, itemsList.map((item, index) => (React.createElement(Item, Object.assign({}, item, { key: `${item.label}_${index}` }))))));
};
export default Accordion;
